import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConsultationService } from '../../services/consultation.service';

@Component({
  selector: 'app-team-testimonials',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './team-testimonials.component.html',
  styleUrl: './team-testimonials.component.scss'
})
export class TeamTestimonialsComponent {
  private consultationService = inject(ConsultationService);

  meetTeamModal() {
    this.consultationService.openModal({ projectType: 'Meet Directors Consultation' });
  }
}
